import { render, staticRenderFns } from "./LoyaltyWidgetConfigIlustra.vue?vue&type=template&id=d7131d5c&scoped=true&"
import script from "./LoyaltyWidgetConfigIlustra.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyWidgetConfigIlustra.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyWidgetConfigIlustra.vue?vue&type=style&index=0&id=d7131d5c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7131d5c",
  null
  
)

export default component.exports